import React from "react";
// import { i18next } from "@translations/kcworks/i18next";
import { Label, Popup } from "semantic-ui-react";
import PropTypes from "prop-types";

const MenuItem = ({ text, icon, url, tabIndex, className = "" }) => {
	return (
		<a role="button" href={url} className={`ui ${className}`.trim()} tabIndex={tabIndex} style={{ display: "inline-flex", alignItems: "center" }}>
			{icon && <span className="material-symbols-outlined icon" style={{ marginRight: "8px" }}>{icon}</span>}
			<span className="inline">{text}</span>
		</a>
	);
};

MenuItem.PropTypes = {
	text: PropTypes.string,
	icon: PropTypes.string,
	url: PropTypes.string,
	tabIndex: PropTypes.number,
	className: PropTypes.string,
};

const IconMenuItem = ({ text, icon, url, badge, tabIndex }) => {
	return (
		<>
			<Popup
				content={text}
				trigger={
					<a
						role="button"
						href={url}
						className="ui computer widescreen large-monitor only"
						tabIndex={tabIndex}
						aria-label={text}
						style={{ display: "inline-flex", alignItems: "center" }}
					>
						<span className="material-symbols-outlined icon" style={{ fontSize: "1.25em" }}>{icon}</span>
						{badge !== undefined && (
							<Label
								className="unread-notifications-badge"
								color="orange"
								floating
							>
								{badge}
							</Label>
						)}
					</a>
				}
			/>

			<a
				role="button"
				href={url}
				className="ui tablet mobile only"
				tabIndex={tabIndex}
				aria-label={text}
				style={{ display: "inline-flex", alignItems: "center" }}
			>
				<span className="material-symbols-outlined icon">{icon}</span>
				<span className="inline" style={{ marginLeft: "0.5rem" }}>
					{text}
				</span>
			</a>
		</>
	);
};

IconMenuItem.PropTypes = {
	text: PropTypes.string,
	icon: PropTypes.string,
	badge: PropTypes.string,
	url: PropTypes.string,
	tabIndex: PropTypes.number,
};

const CollapsingMenuItem = ({
	text,
	icon,
	url,
	tabIndex,
	classnames,
	breakAt = "computer",
}) => {
	return (
		<>
			<Popup
				content={text}
				trigger={
					<a
						role="button"
						href={url}
						className={`ui mobile tablet only ${classnames} collapsing`}
						tabIndex={tabIndex}
						style={{ display: "inline-flex", alignItems: "center" }}
					>
						<span className="material-symbols-outlined icon">{icon}</span>
					</a>
				}
			/>

			{breakAt === "computer" ? (
				<Popup
					content={text}
					trigger={
						<a
							role="button"
							href={url}
							className={`computer only ${classnames} collapsing`}
							tabIndex={tabIndex}
							style={{ display: "inline-flex", alignItems: "center" }}
						>
							<span className="material-symbols-outlined icon">{icon}</span>
						</a>
					}
				/>
			) : (
				<a
					role="button"
					href={url}
					className={`computer only ${classnames} collapsing`}
					tabIndex={tabIndex}
					style={{ display: "inline-flex", alignItems: "center" }}
				>
					<span className="material-symbols-outlined icon" style={{ marginRight: "8px" }}>{icon}</span>
					<span className="inline">{text}</span>
				</a>
			)}

			<a
				role="button"
				href={url}
				className={`ui widescreen large-monitor only ${classnames} collapsing`}
				tabIndex={tabIndex}
				style={{ display: "inline-flex", alignItems: "center" }}
			>
				<span className="material-symbols-outlined icon" style={{ marginRight: "8px" }}>{icon}</span>
				<span className="inline">{text}</span>
			</a>
		</>
	);
};

CollapsingMenuItem.propTypes = {
	text: PropTypes.string,
	icon: PropTypes.string,
	url: PropTypes.string,
	tabIndex: PropTypes.number,
};

export { MenuItem, IconMenuItem, CollapsingMenuItem };
